import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import * as mensajesService from '../../servicios/mensajesService'
import Mensajeria from './Mensajeria'

export const DetallePreguntas = ({
  tipo,
  idPublicacion: idPublicacionProp,
  idVendedor: idVendedorProp
}) => {
  const idUsuario = parseInt(localStorage.getItem('idUsuario'))
  const esVendedor = tipo === 'vendedor'
  const [mensajes, setMensajes] = useState([])
  const { idPublicacion: idPublicacionParam, idVendedor: idVendedorParam } = useParams()
  const idPublicacion = idPublicacionProp ?? parseInt(idPublicacionParam)
  const idVendedor = idVendedorProp ?? parseInt(idVendedorParam)

  const obtenerMensajes = async () => {
    let data = []
    try {
      if (esVendedor) {
        data = (await mensajesService.buscarPorPublicacion(idPublicacion)).data || []
      } else {
        data =
          (
            await mensajesService.buscarEnPublicacionPorComprador(
              idPublicacion,
              idUsuario
            )
          ).data || []
      }
      const map = {}
      const roots = []

      data.forEach((msg) => {
        if (!map[msg.idMensaje]) {
          map[msg.idMensaje] = { ...msg, respuestas: [] }
        }

        const nodo = map[msg.idMensaje]

        if (msg.idMensajePadre) {
          if (!map[msg.idMensajePadre]) {
            map[msg.idMensajePadre] = { respuestas: [] }
          }

          map[msg.idMensajePadre].respuestas.push(nodo)
        } else {
          roots.push(nodo)
        }
      })

      setMensajes(roots)
    } catch {
      setMensajes([])
    }
  }

  useEffect(() => {
    obtenerMensajes()
  }, [idPublicacion, idVendedor, idUsuario])

  return (
    <div className="contenedor-msj">
      <Mensajeria
        idPublicacion={idPublicacion}
        mensajes={mensajes}
        setMensajes={setMensajes}
      />
    </div>
  )
}

DetallePreguntas.propTypes = {
  idPublicacion: PropTypes.number.isRequired,
  idVendedor: PropTypes.number.isRequired,
  tipo: PropTypes.string.isRequired
}

export default DetallePreguntas
